import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/label/label.tsx
import * as LabelPrimitives from "@radix-ui/react-label";
import React from "react";
var Label = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ React.createElement(
    LabelPrimitives.Root,
    {
      className: cn("text-foreground my-label-xs", className),
      ...props,
      ref
    }
  );
});

export {
  Label
};
